import { Paper } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import { AddressLink } from "@dzambalaorg/mui-scanner";
import type { IRaffleToken } from "@framework/types";
import { Table } from "@dzambalaorg/ui-kit";

export interface IRaffleTokenDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IRaffleToken | null;
}

export const RaffleTokenDialogView = (props: IRaffleTokenDialogViewProps) => {
  const { viewItem, onConfirm, open, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { tokenId, round, balance, tokenStatus } = viewItem;

  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <Table.Container component={Paper}>
        <Table aria-label="raffle token table">
          <Table.Body>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.tokenId" />
              </Table.Cell>
              <Table.Cell align="right">{tokenId}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.roundId" />
              </Table.Cell>
              <Table.Cell align="right">{round.roundId}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.winNumber" />
              </Table.Cell>
              <Table.Cell align="right">{round?.number ? round.number : "round not yet finished"}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.tokenStatus" />
              </Table.Cell>
              <Table.Cell align="right">{tokenStatus}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.account" />
              </Table.Cell>
              <Table.Cell align="right">
                <AddressLink address={balance?.at(0)?.account} length={42} />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
    </ConfirmationDialog>
  );
};
